import React from 'react';
import { Text, VStack } from '@chakra-ui/react';
import { MAX_COUNTERS } from 'features/collabs/utils/counterUtils';
import ModalShell from '../../../../components/ui/ModalShell';
import { ff } from '../../../../theme';
import { SheetButton, SheetFooter, SheetHeader } from './sheetParts';

interface CounterOrConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBack: () => void;
  onCounter: () => void;
  onConfirmReject: () => void;
  numTimesCountered: number;
  brandName?: string;
  /** "$50 cash + $0 credit" — the offer on the table. */
  offerLine?: string;
}

/** Decline step 2 for pay / deliverable reasons while a counter is left: counter instead? */
const CounterOrConfirmModal: React.FC<CounterOrConfirmModalProps> = ({
  isOpen,
  onClose,
  onBack,
  onCounter,
  onConfirmReject,
  numTimesCountered,
  brandName = 'The brand',
  offerLine,
}) => {
  const handleBackAndClose = () => {
    onBack();
    onClose();
  };
  const left = Math.max(0, MAX_COUNTERS - numTimesCountered);

  return (
    <ModalShell
      isOpen={isOpen}
      onClose={onClose}
      hideClose
      footer={
        <SheetFooter>
          <SheetButton tone="outline" onClick={onClose}>Cancel</SheetButton>
          <SheetButton tone="redOutline" onClick={onConfirmReject}>Decline anyway</SheetButton>
        </SheetFooter>
      }
    >
      <SheetHeader title="Counter instead?" onClose={onClose} onBack={handleBackAndClose} step={{ index: 2, total: 2, name: 'Counter instead?' }} />
      <VStack align="stretch" spacing="12px" p="16px" borderRadius="18px" bg={ff.limeSurface}>
        <Text fontSize="15px" lineHeight={1.45}>
          {offerLine ? (
            <>
              {brandName} offered <b>{offerLine}</b>.{' '}
            </>
          ) : null}
          You can ask for more instead of saying no. You have {left} {left === 1 ? 'counter' : 'counters'} left on this collab.
        </Text>
        <SheetButton flex="none" h="48px" bg={ff.ink} color={ff.lime} _hover={{ bg: ff.ink }} onClick={onCounter}>
          Send a counter instead
        </SheetButton>
      </VStack>
    </ModalShell>
  );
};

export default CounterOrConfirmModal;
